import script from "./EnrollPortalPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollPortalPage.vue?vue&type=script&setup=true&lang=js"

import "./EnrollPortalPage.vue?vue&type=style&index=0&id=03ccd448&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03ccd448"]])

export default __exports__